import React, { createContext, useEffect, useState } from 'react';
import { msalService } from '@services';
import { WaterIQUserType } from '@types';

const SELECTED_USER_TYPE_KEY = 'selectedUserType';

export interface UserTypeContextState {
	selectedUserType: WaterIQUserType | undefined;
	setSelectedUserType: (userType: WaterIQUserType | undefined) => void;
}

const contextDefaultValues: UserTypeContextState = {
	selectedUserType: undefined,
	setSelectedUserType: () => {
		// do nothing
	},
};

export const UserTypeContext = createContext<UserTypeContextState>(contextDefaultValues);

export const UserTypeContextProvider = ({ children }: { children: React.ReactNode }) => {
	const [selectedUserType, setSelectedUserType] = useState<WaterIQUserType | undefined>(
		initSelectedUserType(),
	);

	/**
	 * Save selected user type on sessionStorage
	 */
	useEffect(() => {
		if (selectedUserType) {
			sessionStorage.setItem(SELECTED_USER_TYPE_KEY, selectedUserType);
		} else {
			sessionStorage.removeItem(SELECTED_USER_TYPE_KEY);
		}
	}, [selectedUserType]);

	function initSelectedUserType() {
		const savedSelectedUserType: WaterIQUserType | undefined = sessionStorage.getItem(
			SELECTED_USER_TYPE_KEY,
		) as WaterIQUserType;
		const accountUserTypes = msalService.getUserTypes();
		const hasValidSavedUserType =
			savedSelectedUserType && accountUserTypes?.includes(savedSelectedUserType);

		if (hasValidSavedUserType) {
			return savedSelectedUserType; // recover selected user type
		} else if (accountUserTypes?.includes(WaterIQUserType.DQP)) {
			return WaterIQUserType.DQP; // default on multiple user types
		} else if (accountUserTypes?.includes(WaterIQUserType.WEH)) {
			return WaterIQUserType.WEH;
		}
	}

	return (
		<UserTypeContext.Provider
			value={{
				selectedUserType,
				setSelectedUserType,
			}}
		>
			{children}
		</UserTypeContext.Provider>
	);
};
